import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFaceId = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-.5 -.5 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("desc", { children: "\n    Face Id Streamline Icon: https://streamlinehq.com\n  " }), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: .5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M4.688 10.55a4.175 4.175 0 0 0 5.625 0M4.219 4.14v1.406M10.781 4.14v1.406M7.5 4.14v3.281a.94.94 0 0 1-.937.938h-.47M14.531 11.64v1.875a.94.94 0 0 1-.937.937h-1.875M11.719.39h1.875a.94.94 0 0 1 .937.938v1.875M.469 3.202V1.327A.94.94 0 0 1 1.406.39h1.875M3.281 14.452H1.406a.94.94 0 0 1-.937-.937V11.64"
	})]
});
export { SvgFaceId as ReactComponent };
